import { useAuth } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { State } from './template'

type Action = {
  passwordResetSend: ({ email }: { email: string }) => Promise<void>
}

export const useViewModel = makeViewModel<State, Action>(() => {
  const { sendPasswordResetEmail } = useAuth()

  return {
    state: {},
    actions: {
      passwordResetSend: async ({ email }) => sendPasswordResetEmail(email),
    },
  }
})
